export default function SvgHome2Icon({ stroke }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      viewBox="0 0 24 25"
    >
      <path
        stroke={stroke || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M9 21.2v-7.4c0-.56 0-.84.109-1.054a1 1 0 01.437-.437c.214-.109.494-.109 1.054-.109h2.8c.56 0 .84 0 1.054.11a1 1 0 01.437.436C15 12.96 15 13.24 15 13.8v7.4M11.018 2.964L4.235 8.24c-.453.353-.68.53-.843.75a2 2 0 00-.318.65C3 9.904 3 10.191 3 10.765V18c0 1.12 0 1.68.218 2.108a2 2 0 00.874.874c.428.218.988.218 2.108.218h11.6c1.12 0 1.68 0 2.108-.218a2 2 0 00.874-.874C21 19.68 21 19.12 21 18v-7.235c0-.574 0-.861-.074-1.126a2.002 2.002 0 00-.318-.65c-.163-.22-.39-.397-.843-.75l-6.783-5.275c-.351-.273-.527-.41-.72-.462a1 1 0 00-.523 0c-.194.052-.37.189-.721.462z"
      ></path>
    </svg>
  )
}
